import axios from 'axios';

export const fetchSettings = async (names = []) => {
  const response = await axios.get('/api/v1/setting', {
    params: {},
    paramsSerializer: () =>
      names.map(n => `names=${encodeURIComponent(n)}`).join('&')
  });

  return response.data.data;
};

const authHeaders = () => ({
  Authorization: localStorage.getItem('token')
});

export const fetchCurrencyRates = async () => {
  try {
    const response = await axios.get('/api/v1/admin/settings/currency-rates', {
      headers: authHeaders()
    });
    const body = response.data;
    const data = body?.data ?? body;
    if (data && typeof data === 'object') return data;
  } catch (err) {
    console.warn('Admin currency rates unavailable, trying public settings', err);
  }
  try {
    return await fetchSettings(['pound_rate', 'dollar_rate', 'euro_rate']) || {};
  } catch (err) {
    console.error('Failed to load currency rates', err);
    return {};
  }
};

export const updateCurrencyRates = async (poundRate, dollarRate, euroRate) => {
  const params = new URLSearchParams();
  if (poundRate != null && poundRate !== '') params.append('poundRate', poundRate);
  if (dollarRate != null && dollarRate !== '') params.append('dollarRate', dollarRate);
  if (euroRate != null && euroRate !== '') params.append('euroRate', euroRate);
  const response = await axios.put(
    `/api/v1/admin/settings/currency-rates?${params.toString()}`,
    {},
    { headers: authHeaders() }
  );
  return response.data.data || {};
};
